/*
  Dropdown
*/

import React from "react";

// Antd
import { Select, Form, Spin, Empty } from "antd";

// Localization
import LOCALIZATION from "../../../..//services/LocalizationService";

import { ArrowIcon } from "assets/icons";
// constants
import { SEARCH_TYPING_INTERVAL } from "constants/General";
// Helper
import { getPlaceholder } from "helpers/GeneralHelper";
import { useEffect } from "react";

const { Option } = Select;

function Dropdown({
  name,
  label,
  showSearch,
  placeholder,
  options,
  onChange,
  defaultValue,
  allowClear,
  disabled,
  required,
  dropdownWidth,
  loading,
  onKeyUp,
  onKeyDown,
  readOnly,
  validator,
  validateTrigger,
  notwrapInForm,
  mode,
  value,
  onClick,
  className,
  onDeselect,
  onClear,
  onSearch,
}) {
  // const sortBy = [{ prop:'text', direction: 1 }];
  // const sortedOption = sortArray(options, sortBy);
  let timeoutId; // timeout will be used for search cases
  const sortedOption = options;

  useEffect(() => {
    return () => clearTimeout(timeoutId);
  });
  // Validations rules
  let rules = [{ required: required, message: LOCALIZATION.REQUIRED }];
  if (!!validator) {
    rules.push({ validator: validator });
  }

  // handle search
  const handleSearch = (value) => {
    // Clear the previous timeout to prevent the API call
    clearTimeout(timeoutId);

    // Set a new timeout to call the API after 500ms
    timeoutId = setTimeout(() => {
      onSearch(value);
    }, SEARCH_TYPING_INTERVAL); // time in mili seconds
  };

  const DropdownList = (
    <Select
      // getPopupContainer={trigger => trigger.parentNode}
      mode={mode}
      aria-required={required}
      showSearch={showSearch === false ? false : true}
      allowClear={allowClear === false ? false : true}
      defaultValue={defaultValue}
      value={value}
      placeholder={placeholder || getPlaceholder(label)} // getplaceholder is a function generate placeholder based on label
      onChange={onChange}
      onKeyUp={onKeyUp}
      onKeyDown={onKeyDown}
      disabled={disabled}
      onClick={onClick}
      loading={loading}
      optionFilterProp="title"
      onDeselect={onDeselect}
      suffixIcon={!disabled ? <ArrowIcon /> : null}
      readOnly={readOnly}
      style={{ width: dropdownWidth || "" }}
      maxTagCount="responsive"
      onClear={onClear}
      notFoundContent={
        loading ? (
          <div style={{ textAlign: "center" }}>
            <Spin size="small" />
          </div>
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }
      onSearch={onSearch ? handleSearch : null}
    >
      {sortedOption &&
        sortedOption.map((data, index) => {
          return (
            <Option
              disabled={data?.disabled}
              id={data?.id}
              key={index}
              title={data.title || data.name}
              value={data.value}
            >
              {data.name}
            </Option>
          );
        })}
    </Select>
  );

  return !!notwrapInForm ? (
    <>{DropdownList}</>
  ) : (
    <Form.Item
      name={name}
      className={className}
      label={label}
      validateTrigger={validateTrigger || "onBlur"}
      rules={rules}
      required={required}
    >
      {DropdownList}
    </Form.Item>
  );
}

export default Dropdown;
